import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form as FormComponent } from 'components/Form'
import { InputForm, TitleForm, SelectForm } from 'components/Form/components'
import { ApiErrors } from 'ui-components/ApiErrors'
import { PAYMENT_METHOD_TYPES } from 'constants/payment-methods'

export default function Form(props) {
  const {
    paymentMethod,
    onCancel,
    onSave,
    saving,
    responseError,
  } = props

  const [attributes, setAttributes] = useState()
  const [selectedType, setSelectedType] = useState()

  useEffect(() => {
    setAttributes(paymentMethod.attributes)
    setSelectedType(PAYMENT_METHOD_TYPES[0])
  }, [paymentMethod])

  const handleSave = () => {
    const attr = {
      ...attributes,
      payment_type: selectedType.value,
    }

    onSave(attr)
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  const handleChangeSelect = (option) => {
    setSelectedType(option)
  }

  return attributes ? (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Forma de pagamento</TitleForm>
      <ApiErrors responseError={responseError} />
      <InputForm
        fullWidth
        label="Nome"
        type="text"
        name="name"
        value={attributes.name}
        onChange={handleChange}
      />
      <SelectForm
        options={PAYMENT_METHOD_TYPES}
        value={selectedType}
        onChange={(option) => handleChangeSelect(option)}
        label="Tipo de forma de pagamento"
        name="unit_type"
      />
    </FormComponent>
  ) : null
}

Form.propTypes = {
  paymentMethod: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  responseError: PropTypes.objectOf(PropTypes.any),
}

Form.defaultProps = {
  paymentMethod: {},
  saving: false,
  responseError: {},
}
